import instance from './API';
import { trim } from 'lodash';

const storePath = '/Store';

// Transform single store object
const transformStore = (store) => {
  if (!store) return store;

  if (
    store.payingMemberBenefits &&
    typeof store.payingMemberBenefits === 'string'
  ) {
    try {
      store.payingMemberBenefits = JSON.parse(store.payingMemberBenefits);
    } catch (e) {
      console.error('Failed to parse payingMemberBenefits:', e);
      store.payingMemberBenefits = null;
    }
  }

  return store;
};

// Transform array of stores
const transformStores = (stores) => {
  if (Array.isArray(stores)) {
    return stores.map(transformStore);
  }
  return transformStore(stores);
};

const storeAPI = {
  getAllStores: () => {
    return instance.get(storePath).then((stores) => transformStores(stores));
  },
  getStores: (page, count) => {
    return instance
      .get('/StoreList', {
        params: {
          page: page,
          count: count,
        },
      })
      .then((res) => {
        return { ...res, storeList: transformStores(res.storeList) };
      });
  },
  getStore: (id) => {
    return instance
      .get(`${storePath}/${id}`)
      .then((store) => transformStore(store));
  },
  getCurrentUserStore: () => {
    return instance
      .get('/CurrentUserStore')
      .then((store) => transformStore(store));
  },
  createOrUpdateStore: (store) => {
    let formData = new FormData();

    // 有 id 為 update，沒有 id 為 create
    if (trim(store.id) !== '') {
      formData.append('StoreId', store.id);
    }

    formData.append('Name', store.name);
    formData.append('PayingMemberBenefits', store.payingMemberBenefits);

    if (trim(store.staffUserId) !== '') {
      formData.append('StaffUserId', store.staffUserId);
    }

    if (trim(store.imageFile) !== '') {
      formData.append('ImageFile', store.imageFile);
    }

    return instance.post('/UpdateStore', formData);
  },
};

export { transformStore, transformStores };
export default storeAPI;
